import { UseCase } from '../UseCase';
import { HistoricRepository } from '../../repositories/HistoricRepository';
import { Sell } from '../../models/Sell';

export class GetHistoricOpsFilteredUseCase implements UseCase<GetHistoricOpsFilteredDto, Sell[]>{

    constructor(
        private historicRepo: HistoricRepository
    ) { }

    execute(t: GetHistoricOpsFilteredDto): Promise<Sell[]> {
        return this.historicRepo.getHistoricTransactionsFiltered(t.date, t.dateEnd, t.page, t.all);
    }
}

export class GetHistoricOpsFilteredDto {
    constructor(
        public date: string,
        public dateEnd: string,
        public page: number,
        public all: boolean = false
    ) { }
}
